var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoFmsManage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ve05z9s1ba"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15408",
    transform: "translate(761 2738)",
    style: {
      fill: "#ff2e2e",
      opacity: 0.158
    },
    d: "M0 0h180v180H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "manage_icon",
    transform: "translate(-761 -2738)",
    style: {
      clipPath: "url(#ve05z9s1ba)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 703",
    transform: "translate(146.5 464.223)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 710"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59607",
    d: "M56.166 83.548H9.839A1.646 1.646 0 0 1 8.193 81.9V51.029a1.646 1.646 0 0 1 1.646-1.646h46.326a1.646 1.646 0 0 1 1.646 1.646V81.9a1.646 1.646 0 0 1-1.646 1.646M9.839 50.165a.862.862 0 0 0-.861.863V81.9a.862.862 0 0 0 .861.861h46.326a.862.862 0 0 0 .861-.861V51.029a.861.861 0 0 0-.861-.861z",
    transform: "translate(628.967 2312.582)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59608",
    d: "M56.166 83.548H9.839A1.646 1.646 0 0 1 8.193 81.9V51.029a1.646 1.646 0 0 1 1.646-1.646h46.326a1.646 1.646 0 0 1 1.646 1.646V81.9a1.646 1.646 0 0 1-1.646 1.646M9.839 50.165a.862.862 0 0 0-.861.863V81.9a.862.862 0 0 0 .861.861h46.326a.862.862 0 0 0 .861-.861V51.029a.861.861 0 0 0-.861-.861z",
    transform: "translate(628.967 2312.582)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59609",
    d: "M36.433 59.969H23.216a1.49 1.49 0 0 1-1.488-1.488v-9.1h16.193v9.1a1.49 1.49 0 0 1-1.488 1.488m-13.924-9.8v8.314a.705.705 0 0 0 .706.7H36.43a.706.706 0 0 0 .706-.7v-8.318z",
    transform: "translate(632.429 2312.582)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59610",
    d: "M36.433 59.969H23.216a1.49 1.49 0 0 1-1.488-1.488v-9.1h16.193v9.1a1.49 1.49 0 0 1-1.488 1.488m-13.924-9.8v8.314a.705.705 0 0 0 .706.7H36.43a.706.706 0 0 0 .706-.7v-8.318z",
    transform: "translate(632.429 2312.582)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59611",
    d: "M68.959 81.554H.894a.391.391 0 0 1-.394-.39v-3.553a1.647 1.647 0 0 1 1.65-1.646h65.557a1.646 1.646 0 0 1 1.646 1.646v3.553a.391.391 0 0 1-.392.391m-67.67-.783h67.277v-3.161a.863.863 0 0 0-.861-.861H2.15a.861.861 0 0 0-.861.861z",
    transform: "translate(627 2319.381)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59612",
    d: "M68.959 81.554H.894a.391.391 0 0 1-.394-.39v-3.553a1.647 1.647 0 0 1 1.65-1.646h65.557a1.646 1.646 0 0 1 1.646 1.646v3.553a.391.391 0 0 1-.392.391m-67.67-.783h67.277v-3.161a.863.863 0 0 0-.861-.861H2.15a.861.861 0 0 0-.861.861z",
    transform: "translate(627 2319.381)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15406",
    transform: "translate(634.348 2400.65)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h55.162v4.095H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59613",
    d: "M7.673 105.475a4.674 4.674 0 0 1-4.668-4.666h.784a3.885 3.885 0 0 0 7.769 0h.782a4.671 4.671 0 0 1-4.669 4.666",
    transform: "translate(627.641 2325.734)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59614",
    d: "M7.673 105.475a4.674 4.674 0 0 1-4.668-4.666h.784a3.885 3.885 0 0 0 7.769 0h.782a4.671 4.671 0 0 1-4.669 4.666",
    transform: "translate(627.641 2325.734)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59615",
    d: "M29.088 105.455c-3.23 0-5.857-2.083-5.857-4.646h.782c0 2.131 2.277 3.863 5.073 3.863s5.074-1.733 5.074-3.863h.784c0 2.562-2.627 4.646-5.858 4.646",
    transform: "translate(632.813 2325.734)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59616",
    d: "M29.088 105.455c-3.23 0-5.857-2.083-5.857-4.646h.782c0 2.131 2.277 3.863 5.073 3.863s5.074-1.733 5.074-3.863h.784c0 2.562-2.627 4.646-5.858 4.646",
    transform: "translate(632.813 2325.734)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59617",
    d: "M50.061 105.475a4.673 4.673 0 0 1-4.668-4.666h.782a3.885 3.885 0 0 0 7.769 0h.782a4.667 4.667 0 0 1-4.668 4.666",
    transform: "translate(638.481 2325.734)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59618",
    d: "M50.061 105.475a4.673 4.673 0 0 1-4.668-4.666h.782a3.885 3.885 0 0 0 7.769 0h.782a4.667 4.667 0 0 1-4.668 4.666",
    transform: "translate(638.481 2325.734)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59619",
    d: "M69.351 95.966H56.889a9.008 9.008 0 0 1-6.584-2.725l-.073-.075a3.748 3.748 0 0 0-2.751-1.252H.5v-4.855h68.851zM1.287 91.128h46.2a4.531 4.531 0 0 1 3.326 1.509l.063.069a8.221 8.221 0 0 0 6.011 2.479h11.681v-7.346H1.287z",
    transform: "translate(627 2322.219)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59620",
    d: "M69.351 95.966H56.889a9.008 9.008 0 0 1-6.584-2.725l-.073-.075a3.748 3.748 0 0 0-2.751-1.252H.5v-4.855h68.851zM1.287 91.128h46.2a4.531 4.531 0 0 1 3.326 1.509l.063.069a8.221 8.221 0 0 0 6.011 2.479h11.681v-7.346H1.287z",
    transform: "translate(627 2322.219)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59621",
    d: "M44.782 90.821a1.062 1.062 0 1 1-1.067-1.056h.005a1.059 1.059 0 0 1 1.061 1.056",
    transform: "translate(637.781 2322.91)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59622",
    d: "M47.579 90.821a1.062 1.062 0 1 1-1.067-1.056h.005a1.058 1.058 0 0 1 1.062 1.056",
    transform: "translate(638.497 2322.91)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59623",
    d: "M50.376 90.821a1.062 1.062 0 1 1-1.067-1.056h.005a1.059 1.059 0 0 1 1.061 1.056",
    transform: "translate(639.212 2322.91)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59624",
    d: "M53.173 90.821a1.062 1.062 0 1 1-1.067-1.056h.005a1.059 1.059 0 0 1 1.062 1.056",
    transform: "translate(639.928 2322.91)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59625",
    d: "M68.96 105.052H.894a.391.391 0 0 1-.392-.391V84.869a1.647 1.647 0 0 1 1.648-1.646h65.557a1.646 1.646 0 0 1 1.646 1.646v19.791a.391.391 0 0 1-.392.392m-67.676-.782h67.283v-19.4a.863.863 0 0 0-.861-.861H2.15a.863.863 0 0 0-.861.861z",
    transform: "translate(627 2321.236)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59626",
    d: "M68.96 105.052H.894a.391.391 0 0 1-.392-.391V84.869a1.647 1.647 0 0 1 1.648-1.646h65.557a1.646 1.646 0 0 1 1.646 1.646v19.791a.391.391 0 0 1-.392.392m-67.676-.782h67.283v-19.4a.863.863 0 0 0-.861-.861H2.15a.863.863 0 0 0-.861.861z",
    transform: "translate(627 2321.236)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 709"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59627",
    d: "M114.572 83.548H68.245A1.646 1.646 0 0 1 66.6 81.9V51.029a1.646 1.646 0 0 1 1.646-1.646h46.326a1.646 1.646 0 0 1 1.646 1.646V81.9a1.646 1.646 0 0 1-1.646 1.646M68.245 50.165a.862.862 0 0 0-.861.863V81.9a.862.862 0 0 0 .861.861h46.326a.862.862 0 0 0 .861-.861V51.029a.861.861 0 0 0-.861-.861z",
    transform: "translate(655.604 2312.582)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59628",
    d: "M114.572 83.548H68.245A1.646 1.646 0 0 1 66.6 81.9V51.029a1.646 1.646 0 0 1 1.646-1.646h46.326a1.646 1.646 0 0 1 1.646 1.646V81.9a1.646 1.646 0 0 1-1.646 1.646M68.245 50.165a.862.862 0 0 0-.861.863V81.9a.862.862 0 0 0 .861.861h46.326a.862.862 0 0 0 .861-.861V51.029a.861.861 0 0 0-.861-.861z",
    transform: "translate(655.604 2312.582)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59629",
    d: "M94.839 59.969H81.622a1.49 1.49 0 0 1-1.488-1.488v-9.1h16.193v9.1a1.49 1.49 0 0 1-1.488 1.488m-13.924-9.8v8.314a.705.705 0 0 0 .706.7h13.215a.706.706 0 0 0 .706-.7v-8.318z",
    transform: "translate(659.066 2312.582)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59630",
    d: "M94.839 59.969H81.622a1.49 1.49 0 0 1-1.488-1.488v-9.1h16.193v9.1a1.49 1.49 0 0 1-1.488 1.488m-13.924-9.8v8.314a.705.705 0 0 0 .706.7h13.215a.706.706 0 0 0 .706-.7v-8.318z",
    transform: "translate(659.066 2312.582)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59631",
    d: "M127.365 81.554H59.3a.391.391 0 0 1-.392-.391v-3.552a1.647 1.647 0 0 1 1.648-1.646h65.557a1.646 1.646 0 0 1 1.646 1.646v3.553a.391.391 0 0 1-.392.391M59.7 80.772h67.278v-3.161a.863.863 0 0 0-.861-.861H60.556a.861.861 0 0 0-.861.861z",
    transform: "translate(653.637 2319.381)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59632",
    d: "M127.365 81.554H59.3a.391.391 0 0 1-.392-.391v-3.552a1.647 1.647 0 0 1 1.648-1.646h65.557a1.646 1.646 0 0 1 1.646 1.646v3.553a.391.391 0 0 1-.392.391M59.7 80.772h67.278v-3.161a.863.863 0 0 0-.861-.861H60.556a.861.861 0 0 0-.861.861z",
    transform: "translate(653.637 2319.381)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15407",
    transform: "translate(719.39 2400.65)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h55.162v4.095H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59633",
    d: "M66.079 105.475a4.674 4.674 0 0 1-4.668-4.666h.784a3.885 3.885 0 0 0 7.769 0h.782a4.671 4.671 0 0 1-4.669 4.666",
    transform: "translate(654.278 2325.734)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59634",
    d: "M66.079 105.475a4.674 4.674 0 0 1-4.668-4.666h.784a3.885 3.885 0 0 0 7.769 0h.782a4.671 4.671 0 0 1-4.669 4.666",
    transform: "translate(654.278 2325.734)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59635",
    d: "M87.494 105.455c-3.23 0-5.857-2.083-5.857-4.646h.782c0 2.131 2.277 3.863 5.073 3.863s5.074-1.733 5.074-3.863h.784c0 2.562-2.627 4.646-5.858 4.646",
    transform: "translate(659.45 2325.734)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59636",
    d: "M87.494 105.455c-3.23 0-5.857-2.083-5.857-4.646h.782c0 2.131 2.277 3.863 5.073 3.863s5.074-1.733 5.074-3.863h.784c0 2.562-2.627 4.646-5.858 4.646",
    transform: "translate(659.45 2325.734)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59637",
    d: "M108.467 105.475a4.673 4.673 0 0 1-4.668-4.666h.782a3.885 3.885 0 0 0 7.769 0h.782a4.667 4.667 0 0 1-4.668 4.666",
    transform: "translate(665.118 2325.734)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59638",
    d: "M108.467 105.475a4.673 4.673 0 0 1-4.668-4.666h.782a3.885 3.885 0 0 0 7.769 0h.782a4.667 4.667 0 0 1-4.668 4.666",
    transform: "translate(665.118 2325.734)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59639",
    d: "M127.758 95.966H115.3a9.008 9.008 0 0 1-6.584-2.725l-.074-.075a3.744 3.744 0 0 0-2.75-1.252H58.905v-4.855h68.853zm-68.066-4.838h46.2a4.526 4.526 0 0 1 3.325 1.509l.063.069a8.223 8.223 0 0 0 6.013 2.479h11.678v-7.346H59.692z",
    transform: "translate(653.637 2322.219)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59640",
    d: "M127.758 95.966H115.3a9.008 9.008 0 0 1-6.584-2.725l-.074-.075a3.744 3.744 0 0 0-2.75-1.252H58.905v-4.855h68.853zm-68.066-4.838h46.2a4.526 4.526 0 0 1 3.325 1.509l.063.069a8.223 8.223 0 0 0 6.013 2.479h11.678v-7.346H59.692z",
    transform: "translate(653.637 2322.219)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59641",
    d: "M103.188 90.821a1.062 1.062 0 1 1-1.067-1.056h.005a1.059 1.059 0 0 1 1.061 1.056",
    transform: "translate(664.419 2322.91)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59642",
    d: "M105.985 90.821a1.062 1.062 0 1 1-1.067-1.056h.005a1.058 1.058 0 0 1 1.062 1.056",
    transform: "translate(665.134 2322.91)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59643",
    d: "M108.782 90.821a1.062 1.062 0 1 1-1.067-1.056h.005a1.059 1.059 0 0 1 1.061 1.056",
    transform: "translate(665.849 2322.91)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59644",
    d: "M111.579 90.821a1.062 1.062 0 1 1-1.067-1.056h.005a1.059 1.059 0 0 1 1.062 1.056",
    transform: "translate(666.564 2322.91)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59645",
    d: "M127.366 105.052H59.3a.391.391 0 0 1-.392-.391V84.869a1.647 1.647 0 0 1 1.648-1.646h65.557a1.646 1.646 0 0 1 1.646 1.646v19.791a.391.391 0 0 1-.392.392m-67.676-.782h67.283v-19.4a.863.863 0 0 0-.861-.861H60.556a.863.863 0 0 0-.861.861z",
    transform: "translate(653.637 2321.236)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59646",
    d: "M127.366 105.052H59.3a.391.391 0 0 1-.392-.391V84.869a1.647 1.647 0 0 1 1.648-1.646h65.557a1.646 1.646 0 0 1 1.646 1.646v19.791a.391.391 0 0 1-.392.392m-67.676-.782h67.283v-19.4a.863.863 0 0 0-.861-.861H60.556a.863.863 0 0 0-.861.861z",
    transform: "translate(653.637 2321.236)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#fff",
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59647",
    d: "M28.176 45.651v-7.967h83.074v7.968",
    transform: "translate(635.075 2306.362)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 104",
    cx: 7.942,
    cy: 7.942,
    r: 7.942,
    transform: "translate(696.847 2307.935)",
    style: {
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59648",
    d: "M81.633 23.673v-6.008a.69.69 0 0 0-.69-.69h-4.237a.689.689 0 0 1-.657-.5 14.682 14.682 0 0 0-1.159-2.8.686.686 0 0 1 .11-.819l2.994-3a.689.689 0 0 0 0-.975l-4.247-4.244a.691.691 0 0 0-.975 0l-2.994 3a.689.689 0 0 1-.819.112 14.553 14.553 0 0 0-2.8-1.159.689.689 0 0 1-.5-.657V1.691a.689.689 0 0 0-.69-.69H58.96a.689.689 0 0 0-.69.69v4.237a.689.689 0 0 1-.5.657 14.552 14.552 0 0 0-2.8 1.159.688.688 0 0 1-.819-.112l-3-3a.691.691 0 0 0-.975 0l-4.244 4.253a.691.691 0 0 0 0 .975l3 3a.686.686 0 0 1 .112.818 14.6 14.6 0 0 0-1.159 2.8.689.689 0 0 1-.657.5h-4.242a.69.69 0 0 0-.69.69v6.008a.69.69 0 0 0 .69.69h4.237a.689.689 0 0 1 .657.5 14.552 14.552 0 0 0 1.159 2.8.689.689 0 0 1-.112.819l-3 2.994a.691.691 0 0 0 0 .975L50.18 36.7a.689.689 0 0 0 .975 0l3-2.994a.688.688 0 0 1 .819-.112 14.635 14.635 0 0 0 2.8 1.159.687.687 0 0 1 .5.657v4.237a.69.69 0 0 0 .69.69h6.008a.69.69 0 0 0 .69-.69v-4.236a.687.687 0 0 1 .5-.657 14.636 14.636 0 0 0 2.8-1.159.689.689 0 0 1 .819.112l2.991 2.993a.689.689 0 0 0 .975 0L78 32.452a.689.689 0 0 0 0-.975l-3-2.995a.689.689 0 0 1-.112-.819 14.635 14.635 0 0 0 1.159-2.8.689.689 0 0 1 .657-.5h4.237a.69.69 0 0 0 .692-.69z",
    transform: "translate(642.823 2295.209)",
    style: {
      stroke: "#4cbbb8",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "none"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFmsManage);
export default __webpack_public_path__ + "static/media/ico_fms_manage.6854f68a0b9d34eed7d5ee943ab10fb7.svg";
export { ForwardRef as ReactComponent };